export const SET_CURRENT_USER = "SET_CURRENT_USER"
export const SET_USER_IS_LOGGED_IN = "SET_USER_IS_LOGGED_IN"
